import {Label} from '@primer/react'
import type {LabelProps} from '@primer/react'
import type {SignatureResult, VerificationStatus} from './signed-commit-types'
import {SignedCommitDialog} from './SignedCommitDialog'
import {useState, useRef} from 'react'

export interface SignedCommitBadgeProps {
  hasSignature: boolean
  verificationStatus: VerificationStatus
  signature: SignatureResult
  badgeSize?: LabelProps['size']
}

export function SignedCommitBadge({
  hasSignature,
  verificationStatus,
  signature,
  badgeSize = 'small',
}: SignedCommitBadgeProps) {
  const [isOpen, setIsOpen] = useState(false)
  const badgeRef = useRef<HTMLButtonElement>(null)

  if (verificationStatus === 'unsigned') {
    return <></>
  }

  const defaultProps = {
    onClick: () => setIsOpen(true),
    ref: badgeRef,
  }
  const anchorProps: {sx: LabelProps['sx']; size: LabelProps['size']} = {sx: {cursor: 'pointer'}, size: badgeSize}

  const verification_label =
    verificationStatus === 'verified' ? (
      <Label as="button" variant="success" {...anchorProps} {...defaultProps}>
        Verified
      </Label>
    ) : verificationStatus === 'unverified' ? (
      <Label as="button" variant="attention" {...anchorProps} {...defaultProps}>
        Unverified
      </Label>
    ) : verificationStatus === 'partially_verified' ? (
      <Label as="button" variant="success" {...anchorProps} {...defaultProps}>
        Partially verified
      </Label>
    ) : (
      <></>
    )

  return (
    <>
      {verification_label}
      {isOpen && (
        <SignedCommitDialog
          isOpen={isOpen}
          onDismiss={() => {
            setIsOpen(false)
            setTimeout(() => {
              badgeRef.current?.focus()
            }, 0)
          }}
          verificationStatus={verificationStatus}
          signature={signature}
          hasSignature={hasSignature}
        />
      )}
    </>
  )
}

try{ SignedCommitBadge.displayName ||= 'SignedCommitBadge' } catch {}